import { h } from '@/lib/dom';
import { InfoTip } from '@/components/InfoTip';

export interface TopTileProps {
  label: string;
  value: string;
  tooltip: string;
  sub?: string;
}

export function TopTile({ label, value, tooltip, sub }: TopTileProps): HTMLElement {
  return h('div', { class: 'sleep-top-tile' }, [
    h('div', { class: 'sleep-top-tile-head' }, [
      h('span', { class: 'sleep-top-label' }, label),
      InfoTip(tooltip, label),
    ]),
    h('span', { class: 'sleep-top-value' }, value),
    sub ? h('span', { class: 'sleep-top-sub' }, sub) : null,
  ]);
}
